import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';

import { useScreenSizeContext } from '@/components/ScreenSize.context';

const NavBarMobile = dynamic(() => import('@/components/layout/navbar/mobile/NavBarMobile'));
NavBarMobile.displayName = 'NavBarMobile';
const NavBarDesktop = dynamic(() => import('@/components/layout/navbar/desktop/NavBarDesktop'));
NavBarDesktop.displayName = 'NavBarDesktop';

export const NavBar = ({ navBarMenu, onClickMenu }) => {
  const { isMobileOrTablet } = useScreenSizeContext();

  return isMobileOrTablet ? (
    <NavBarMobile navBarMenu={navBarMenu} />
  ) : (
    <NavBarDesktop navBarMenu={navBarMenu} onClickMenu={onClickMenu} />
  );
};

NavBar.propTypes = {
  navBarMenu: PropTypes.array.isRequired,
  onClickMenu: PropTypes.func.isRequired
};

export default React.memo(NavBar);
